import { createFileRoute } from '@tanstack/react-router';

import { EmployeeProfile } from '@/components/employee/profile';

export const Route = createFileRoute('/(app)/company/employees/$employeeId')({
  component: EmployeeDetailsRoute,
});

function EmployeeDetailsRoute() {
  const { employeeId } = Route.useParams();
  const employeeIdNum = Number(employeeId);

  return (
    <EmployeeProfile
      employeeId={employeeIdNum}
      showEditButton
      showBackButton
      backPath="/company/employees"
      viewContext="company"
    />
  );
}
